import React, { FunctionComponent, Fragment } from 'react';
import { Route } from 'react-router-dom';
import RadiusParserOptionsEdit from './containers/RadiusParserOptionsEdit';
import RadiusParserOptionsView from './containers/RadiusParserOptionsView';
import { SYSTEM_CONFIGURATION_ROUTE, RADIUS_PARSER_OPTIONS, NETWORK } from '../../constants';

interface Props {
}

const RadiusParserOptions: FunctionComponent<Props> = () => {
  return (
    <Fragment>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${RADIUS_PARSER_OPTIONS}`}>
        <RadiusParserOptionsView />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${RADIUS_PARSER_OPTIONS}/edit`}>
        <RadiusParserOptionsEdit />
      </Route>
    </Fragment>
  );
};

export default RadiusParserOptions;
